import TabPanel from "../../../components/TabPanel";
import { useContext } from "react";
import Box from "@mui/material/Box";
import MainContext from "../../../context/mainContext";
import AccessDeny from "../AccessDeny";
import Supports from "./Boxs/Supports/Supports";
import Tickets from "./Boxs/Tickets/Tickets";

function SupportTabs(props) {
  const { userTypes } = useContext(MainContext);

  const { supportTabsValue } = props;

  return (
    <Box component="main">
      <TabPanel value={supportTabsValue} index={0}>
        <Supports />
      </TabPanel>
      <TabPanel value={supportTabsValue} index={1}>
        {userTypes.length > 0 ? <Tickets /> : <AccessDeny />}
      </TabPanel>
    </Box>
  );
}

export default SupportTabs;
